module.exports = __webpack_public_path__ + "static/nails-on-ninth-salon-acdfeb009eeb9a6379950c6b5e1acb66.gif";